var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"video-container"},[_c('div',{ref:"xdvideo",staticClass:"web-video-xd",attrs:{"data-vid":_vm.vid,"data-options":_vm.opts}})])}
var staticRenderFns = []

export { render, staticRenderFns }